import { useQuery } from "@tanstack/react-query";
import { client } from "../../utils/axiosClient";

const queryConfig = {
  enabled: true,
  refetchInterval: 1800000,
  staleTime: Infinity,
  placeholderData: (prev: any) => prev,
};

export const useGetTenantProjects = () => {
  return useQuery({
    queryKey: ["tenantProjects"],
    queryFn: async () => {
      const response = await client.get(`/time-estimate/get-all-projects`);
      return response.data;
    },
    ...queryConfig,
  });
};

export const useGetProjectMembers = (projectId) => {
  return useQuery({
    queryKey: ["projectMembers", projectId],
    queryFn: async () => {
      const response = await client.get(`/time-estimate/get-project-members`, {
        params: { projectId },
      });
      return response.data;
    },
    ...queryConfig,
  });
};

export const useGetProjectWeeks = (projectId) => {
  return useQuery({
    queryKey: ["projectWeeks", projectId],
    queryFn: async () => {
      const response = await client.get(`/time-estimate/get-weeks`, {
        params: { projectId },
      });
      return response.data.weeksWithAssigneesAndNames1;
    },
    enabled: !!projectId,
    refetchInterval: 1800000,
    staleTime: Infinity,
    placeholderData: (prev: any) => prev,
  });
};